<template>
  <product-variant-selection
    v-model="attributeSelection"
    v-model:form-ref="attributeSelectionFormRef"
    v-bind="forwarded"
  />
</template>

<script lang="ts" setup>
import type { Emits, Props } from '#brand/regions/nora/components/product/variant-selection/VariantSelection.vue'
import ProductVariantSelection from '#brand/regions/nora/components/product/variant-selection/VariantSelection.vue'

const props = defineProps<Props>()
const emit = defineEmits<Emits>()
const forwarded = useForwardPropsEmits(props, emit)

const { $feature } = useNuxtApp()
const { brandClasses } = useAppConfig().pages.pdp
const { attributeSelection, attributeSelectionFormRef } = usePdp()

if ($feature.tempShowATCAboveFold) {
  brandClasses.variantSelectionBadgeLabel = 'elevate-body-3 lg:text-xs'
  brandClasses.variantSelectionGroupedOptions = 'mt-4 lg:mt-2'
  brandClasses.variantSelectionWrapper = 'mt-8 space-y-8 lg:mt-4 lg:space-y-4'
}
</script>
